export default __webpack_public_path__ + "static/media/detail_big_10_2.cbb31b2d.jpg";